import { login } from '@api/lambda/user';
import { useMutation } from '@tanstack/react-query';

const useLogin = options =>
  useMutation({
    mutationFn: login,
    mutationKey: ['login'],
    ...options,
  });

export default useLogin;
